import React from "react";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import FolderIcon from "@mui/icons-material/Folder";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { List, ListItem, ListItemText, ListItemButton, Collapse, ListItemIcon } from "@mui/material";
import Backend from "services/Backend";
import BaseComponent from "base";
import { injectIntl } from "react-intl";

class CategoryTree extends BaseComponent {
  constructor(props) {
    super(props);
  }
  state = { open: {} };

  componentDidMount() {
    Backend.fetchCategories()
      .then((categories) => {
        this.setState({ categories });
      })
      .catch((e) => {
        console.error(e);
      });
  }

  componentDidUpdate(prevProps) {
    const rootId = "00000000-0000-0000-0000-000000000000";
    if (this.props.resetTreeTrigger != null && this.props.resetTreeTrigger !== prevProps.resetTreeTrigger) {
      const root = this.state.categories;
      const nextOpen = { [rootId]: true };
      if (root && root.children) {
        const closeNode = (node) => {
          nextOpen[node.id] = false;
          if (node.children) {
            node.children.forEach(closeNode);
          }
        };
        root.children.forEach(closeNode);
      }
      // Reset tree open state when parent triggers reset (e.g. Rensa button)
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ open: nextOpen });
    }
  }

  handleTouchTap(selected) {
    if (this.props.onChange && this.state.open[selected.id]) {
      if (this.props.selectedId !== selected.id && selected.id !== "00000000-0000-0000-0000-000000000000") {
        if (this.props.subscribeCategories) {
          this.props.onChange(selected);
        } else {
          this.props.onChange(selected.id);
        }
      } else {
        this.props.onChange(null);
      }
    }
  }
  isItemSelected(item, selectedId) {
    const isSelected = item.id === selectedId;
    const childSelected = item.children.some((child) => this.isItemSelected(child, selectedId));
    return isSelected || childSelected;
  }
  renderListItem(item, index, parentItem, level1Ancestor) {
    const rootId = "00000000-0000-0000-0000-000000000000";
    const open = this.state.open;
    const root = this.state.categories;
    if (!item) {
      return <span />;
    }

    const hasChildren = item.children.length;
    const isLevel1 = parentItem && parentItem.id === rootId;

    return (
      <React.Fragment key={item.id}>
        <ListItem alignItems="flex-start" disablePadding>
          {" "}
          <ListItemIcon>{hasChildren ? <FolderIcon /> : <InsertDriveFileIcon />}</ListItemIcon>
          <ListItemButton
            key={index}
            onClick={() => {
              if (item.id === rootId) {
                const nextOpen = { [rootId]: true };
                if (root && root.children) {
                  const closeNode = (node) => {
                    nextOpen[node.id] = false;
                    if (node.children) {
                      node.children.forEach(closeNode);
                    }
                  };
                  root.children.forEach(closeNode);
                }
                this.setState((prevState) => ({ ...prevState, open: nextOpen }));
                if (this.props.onChange) {
                  this.props.onChange(null);
                }
                return;
              }

              const currentlyOpen = open[item.id];
              const willBeOpen = hasChildren ? !currentlyOpen : true;
              const nextOpen = { ...open };
              nextOpen[item.id] = willBeOpen;

              if (willBeOpen && hasChildren && root && root.children) {
                const currentLevel1 = isLevel1 ? item : level1Ancestor;
                if (currentLevel1) {
                  root.children.forEach((sibling) => {
                    if (sibling.id !== currentLevel1.id) {
                      nextOpen[sibling.id] = false;
                    }
                  });
                }
              }

              this.setState((prevState) => ({
                ...prevState,
                open: nextOpen,
              }));

              if (hasChildren) {
                if (willBeOpen && this.props.onChange) {
                  this.props.onChange(this.props.subscribeCategories ? item : item.id);
                } else if (!willBeOpen && this.props.onChange) {
                  const selectedIsThisOrDescendant = this.isItemSelected(item, this.props.selectedId);
                  if (selectedIsThisOrDescendant && parentItem) {
                    this.props.onChange(this.props.subscribeCategories ? parentItem : parentItem.id);
                  } else {
                    this.props.onChange(null);
                  }
                }
              } else {
                this.handleTouchTap(item);
              }
            }}
            selected={this.isItemSelected(item, this.props.selectedId)}>
            <ListItemText primary={`${this.getCategoryName(item)} `} />
            {hasChildren ? open[item.id] ? <ExpandLess /> : <ExpandMore /> : null}
          </ListItemButton>
        </ListItem>
        {hasChildren ? (
          <Collapse key={index} in={item.id === rootId ? true : open[item.id]} timeout="auto" unmountOnExit>
            <List sx={{ pl: 4 }}>{item.children.map((child, i) => this.renderListItem(child, i, item, isLevel1 ? item : level1Ancestor))}</List>
          </Collapse>
        ) : (
          <span />
        )}
      </React.Fragment>
    );
  }

  getCategoryName(item) {
    // Translate the root "All categories" node
    if (item.id === "00000000-0000-0000-0000-000000000000") {
      return this.props.intl.formatMessage({ id: "search.allCategories" });
    }
    return item.name;
  }

  render() {
    if (!this.state.categories) {
      return <span />;
    }

    return <List>{this.renderListItem(this.state.categories, -1, null, null)}</List>;
  }
}

export default injectIntl(CategoryTree);
